/* ═══════════════════════════════════════════════════════════
   SPAACIO — Favoritos (wishlist)
   Vanilla, sin jQuery. Módulo único que reemplaza `likeProduct`
   + `buildFavorite` del tema Wokiee.

   CONTRATO DE ALMACENAMIENTO — se preserva tal cual para no perder los
   favoritos ya guardados por los clientes en producción. NO cambiar:
     localStorage["product_favorite_v2_" + handle] = "true"
     localStorage["numFavoritosV2"]                = <conteo>

   CONTRATO DE DOM (Atelier):
     Botón de toggle → [data-fav-toggle] con:
       data-fav-handle   (obligatorio, clave de almacenamiento)
       data-fav-id       (id de producto, para la API del Business Hub)
       data-fav-title / data-fav-price / data-fav-compare / data-fav-image
                         (payload para la API; opcionales)
     Contador de header → [data-fav-count]
     Estado activo del botón → clase .is-active (ya estilada en base.css)

   API pública → Atelier.Favoritos.{ isFavorite, getHandles, getCount,
                 toggle, hydrate }  ·  evento 'atelier:favorites:changed'
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var PREFIX = 'product_favorite_v2_';
  var COUNT_KEY = 'numFavoritosV2';
  // Endpoint del Business Hub. Sobrescribible desde el theme si cambia el deploy.
  var API_URL = window.SPAACIO_FAVORITOS_API || 'https://spaacio-business-hub.vercel.app/api/favoritos';

  window.Atelier = window.Atelier || {};

  var favUrl = null; // URL de la página de favoritos (para el toast); se resuelve en hydrate()

  /* ── localStorage tolerante (modo privado / cuota llena) ────── */
  function safeGet(key)      { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function safeSet(key, val) { try { window.localStorage.setItem(key, val); return true; } catch (e) { return false; } }
  function safeRemove(key)   { try { window.localStorage.removeItem(key); } catch (e) {} }

  function getHandles() {
    var out = [];
    try {
      for (var i = 0; i < window.localStorage.length; i++) {
        var k = window.localStorage.key(i);
        if (k && k.indexOf(PREFIX) === 0) {
          var h = k.slice(PREFIX.length);
          if (h) out.push(h);
        }
      }
    } catch (e) {}
    return out;
  }
  function isFavorite(handle) { return !!handle && safeGet(PREFIX + handle) === 'true'; }
  function getCount() { return getHandles().length; }

  /* ── Toast mínimo (reemplaza el .toast de jQuery) ───────────── */
  var toastEl, toastTimer;
  function toast(msg, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = opts.href ? '<a href="' + opts.href + '">' + msg + '</a>' : msg;
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth; // reinicia la animación
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, opts.duration || 3000);
  }
  Atelier.toast = toast;

  /* ── Contador de header (mismo patrón que el del carrito) ───── */
  function updateHeaderCount(n) {
    var badges = document.querySelectorAll('[data-fav-count]');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      b.textContent = n;
      if (n > 0) {
        b.hidden = false;
        b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
      } else {
        b.hidden = true;
      }
    }
  }

  /* ── Reflejar estado activo en TODOS los botones de un handle ── */
  function reflectButtons(handle, active) {
    var btns = document.querySelectorAll('[data-fav-toggle]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-fav-handle') === handle) {
        btns[i].classList.toggle('is-active', active);
        btns[i].setAttribute('aria-pressed', active ? 'true' : 'false');
        btns[i].setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Agregar a favoritos');
      }
    }
  }

  /* ── Business Hub API — fuente única, expuesta como window.favoritosAPI ──
     Drop-in con spaacio-favoritos-api.js (mismos métodos y payload). Ángel ve
     estos favoritos en la app de Shopify. NO cargar el snippet suelto además de
     esto: quedaría definido dos veces. Fire-and-forget: no bloquea la UI. */
  function postApi(body) {
    return fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    })
      .then(function (r) { return r.json().catch(function () { return { success: true }; }); })
      .catch(function (error) { return { success: false, error: error && error.message }; });
  }

  var favoritosAPI = {
    agregar: function (productData) {
      return postApi({
        action: 'agregar',
        productId: String(productData.productId),
        handle: productData.handle,
        nombre: productData.nombre,
        price: productData.price,
        compareAtPrice: productData.compareAtPrice,
        image: productData.image
      });
    },
    quitar: function (productId) {
      return postApi({ action: 'quitar', productId: String(productId) });
    }
  };
  window.favoritosAPI = favoritosAPI;
  Atelier.favoritosAPI = favoritosAPI;

  /* ── Hook para otras vistas (la página de favoritos escucha esto) */
  function emitChanged(handle, isFav, count) {
    document.dispatchEvent(new CustomEvent('atelier:favorites:changed', {
      detail: { handle: handle, isFavorite: isFav, count: count }
    }));
  }

  /* ── Toggle principal ───────────────────────────────────────── */
  function toggle(payload) {
    var handle = payload && payload.handle;
    if (!handle) return;

    var nowFav;
    if (isFavorite(handle)) { safeRemove(PREFIX + handle); nowFav = false; }
    else                    { safeSet(PREFIX + handle, 'true'); nowFav = true; }

    var count = getCount();
    safeSet(COUNT_KEY, String(count));

    reflectButtons(handle, nowFav);
    updateHeaderCount(count);
    if (payload.id) {
      if (nowFav) {
        favoritosAPI.agregar({
          productId: payload.id, handle: payload.handle, nombre: payload.title,
          price: payload.price, compareAtPrice: payload.compare, image: payload.image
        });
      } else {
        favoritosAPI.quitar(payload.id);
      }
    }

    toast(
      nowFav ? '¡Listo! Se agregó a favoritos.' : 'Se quitó de favoritos.',
      (nowFav && favUrl) ? { href: favUrl } : {}
    );
    emitChanged(handle, nowFav, count);
    return nowFav;
  }

  function payloadFromButton(btn) {
    var compare = btn.getAttribute('data-fav-compare');
    return {
      handle: btn.getAttribute('data-fav-handle'),
      id:     btn.getAttribute('data-fav-id'),
      title:  btn.getAttribute('data-fav-title') || '',
      price:  parseInt(btn.getAttribute('data-fav-price'), 10) || 0,
      compare: compare ? (parseInt(compare, 10) || null) : null,
      image:  btn.getAttribute('data-fav-image') || ''
    };
  }

  /* ── Hidratar en carga: marcar activos + contador + URL ─────── */
  function hydrate() {
    var favLink = document.querySelector('.header__icon[aria-label="Favoritos"], [data-fav-link]');
    if (favLink) favUrl = favLink.getAttribute('href');

    var btns = document.querySelectorAll('[data-fav-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var h = btns[i].getAttribute('data-fav-handle');
      var active = isFavorite(h);
      btns[i].classList.toggle('is-active', active);
      btns[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    updateHeaderCount(getCount());
  }

  /* ── Delegación de eventos (funciona con contenido inyectado) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fav-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(payloadFromButton(btn));
  });

  /* ── API pública ────────────────────────────────────────────── */
  Atelier.Favoritos = {
    isFavorite: isFavorite,
    getHandles: getHandles,
    getCount: getCount,
    hydrate: hydrate,
    updateHeaderCount: updateHeaderCount,
    toggle: function (handleOrBtn) {
      if (typeof handleOrBtn === 'string') return toggle({ handle: handleOrBtn });
      if (handleOrBtn && handleOrBtn.nodeType === 1) return toggle(payloadFromButton(handleOrBtn));
      return toggle(handleOrBtn);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
